import React from "react";
import { Badge, Col, Row, Table, Tag, Typography } from "antd";
import type { TableProps } from "antd";
import CopyIcon from "./../../../assets/svgs/CopyIcon.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import { formatDate } from "../../../helpers/date";
import "./index.css";
import useMultiNotification from "../../../hooks/useNotification";
import NetwalaButton from "../Button/Index";
import { ButtonProps } from "../../../helpers/constants";
import { useNavigate } from "react-router-dom";

const SMSBotProbesTable: React.FC<SMSBotProbesTableProp> = ({ bots }) => {
  const { openNotification, contextHolder } = useMultiNotification();
  const navigate = useNavigate();
  const columns: TableProps<SMSBotProbe>["columns"] = [
    {
      title: "View Recent Activity",
      render: (row) => (
        <NetwalaButton
          backgroundColor={ButtonProps.background.STANDARD}
          height={ButtonProps.height.STANDARD}
          width={`100%`}
          textColor={ButtonProps.color.STANDARD}
          onClick={() => {
            navigate(`/sms-bots/view-recent-activity/${row.intPkSMSProbeID}`);
          }}
          text="View Recent Activity"
        />
      ),
    },
    {
      title: "Status",
      render: (row) => (
        <Tag color={row.activityDetails.isActive ? "success" : "error"}>
          {row.activityDetails.isActive ? "Online" : "Offline"}
        </Tag>
      ),
    },
    {
      title: "Name",
      render: (text) => (
        <Typography
          style={{ display: "flex", alignContent: "center", gap: "10px" }}
        >
          {text || "---"}
        </Typography>
      ),
      key: "probeName",
      dataIndex: "probeName",
    },
    {
      title: "Last Message Sent",
      render: (row) => (
        <Typography
          style={{ display: "flex", alignContent: "center", gap: "10px" }}
        >
          {row.activityDetails.lastMessageSentTime
            ? formatDate(new Date(row.activityDetails.lastMessageSentTime))
            : "---"}
        </Typography>
      ),
    },
    {
      title: "Active Slots",
      render: (row) => (
        <Typography
          style={{ display: "flex", alignContent: "center", gap: "10px" }}
        >
          {row.activityDetails.activeSlots}
        </Typography>
      ),
    },
    {
      title: "Username",
      render: (row) => (
        <Typography
          style={{ display: "flex", alignContent: "center", gap: "10px" }}
        >
          {row.probeUserName}
          <CopyToClipboard
            text={row.probeUserName || ""}
            onCopy={() => {
              openNotification(
                "success",
                "Copied",
                "Username copied to clipboard"
              );
            }}
          >
            <img
              onClick={(e) => {
                e.preventDefault();
              }}
              src={CopyIcon}
              className="cursor-pointer "
            />
          </CopyToClipboard>
        </Typography>
      ),
    },
    {
      title: "Password",
      render: (row) => (
        <Typography
          style={{ display: "flex", alignContent: "center", gap: "10px" }}
        >
          {row.probePassword}
          <CopyToClipboard
            text={row.probePassword || ""}
            onCopy={() => {
              openNotification(
                "success",
                "Copied",
                "Password copied to clipboard"
              );
            }}
          >
            <img
              onClick={(e) => {
                e.preventDefault();
              }}
              src={CopyIcon}
              className="cursor-pointer "
            />
          </CopyToClipboard>
        </Typography>
      ),
    },

    {
      title: "Created",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <span>{formatDate(new Date(text))}</span>,
    },
  ];

  return (
    <>
      {contextHolder}
      <div className="netwala-users-table-container">
        <Row>
          <Col span={24}>
            <Typography className="netwala-user-tables-heading">
              SMS Probe Bots
            </Typography>
            <Table
              className="netwala-users-table striped-table"
              columns={columns}
              dataSource={bots}
              pagination={false}
              scroll={{ x: "max-content" }}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};
export default SMSBotProbesTable;
